<form #dipApplicantForm="ngForm" [formGroup]="tad_applicant_details_form">
  <ol class="c-applicant-list">
    <li>
      <div class="c-applicant-list__item">
        @if (is_business_applicant == false) {
          <span class="c-applicant-list__number">Applicant {{applicant.Instance.ApplicantSequence}}</span>
        }
        @if (is_business_applicant == true) {
          <span class="c-applicant-list__number">Applicant {{applicant.Instance.ApplicantSequence-1}}</span>
        }
        <span class="c-applicant-list__detail">
          @if (applicant.Instance.hasFullName()) {
            <span class="c-applicant-list__name">{{applicant.Instance.FullName}}</span>
          }
          @if (!applicant.Instance.hasFullName() && is_business_applicant == false) {
            <span class="c-applicant-list__name">Applicant {{applicant.Instance.ApplicantSequence}}</span>
          }
          @if (!applicant.Instance.hasFullName() && is_business_applicant == true) {
            <span class="c-applicant-list__name">Applicant {{applicant.Instance.ApplicantSequence-1}}</span>
          }
          @if (canDeleteApplicant) {
            <button class="c-applicant-list__action c-button" type="button" aria-expanded="true" (click)="_toggleDeleteDialog()">Remove applicant</button>
          }
          <button class="c-applicant-list__action c-button c-button--icon-drop" type="button" (click)="_toggleApplicantDetails()">
            <span class="visually-hidden">Open detail</span>

            @if (!_isApplicantDetailsVisible()) {
              <svg class="c-button__icon icon-drop" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                focusable="false" viewBox="0 0 29 19">
                <rect id="backgroundrect" width="100%" height="100%" x="0" y="0" fill="none" stroke="none" />
                <g class="currentLayer">
                  <path fill="none" stroke="#3f2b56" stroke-width="7" d="M25.5 3.5l-11 12-11-12" stroke-linecap="round" stroke-linejoin="round"
                    id="svg_1" class="" transform="rotate(-0.6902841329574585 14.499999999999808,9.499999999999968) " />
                  </g>
                </svg>
              }
              @if (_isApplicantDetailsVisible()) {
                <svg class="c-button__icon icon-drop" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                  focusable="false" viewBox="0 0 29 19">
                  <rect id="backgroundrect" width="100%" height="100%" x="0" y="0" fill="none" stroke="none" />
                  <g class="currentLayer">
                    <path fill="none" stroke="#3f2b56" stroke-width="7" d="M25.5 3.5l-11 12-11-12" stroke-linecap="round" stroke-linejoin="round"
                      id="svg_1" class="" transform="rotate(-179.99998474121094 14.5,9.5) " />
                    </g>
                  </svg>
                }
              </button>
            </span>
          </div>
          @if (_isDeleteDialogVisible()) {
            <div class="c-applicant-list__expanded is-active p-3" aria-hidden="false">
              <div class="c-applicant-list__expanded-body">
                <p>
                  <strong>Are you sure you want to remove '{{applicant.Instance.getFullName()}}' from the application?</strong>
                </p>
                <p>This data cannot be retrieved once deleted.</p>
              </div>
              <button class="c-button c-button--input-brand" type="button" (click)="_handleDeleteApplicant()">Yes, I'm sure</button>
              <button class="c-button c-button--input" type="button" (click)="_toggleDeleteDialog()">No, don't remove</button>
            </div>
          }
        </li>
      </ol>
      @if (_isApplicantDetailsVisible()) {
        <div class="applicant-container">
          <div class="row">
            <div class="col-12 col-md-9">
              <applicant-title [(title)]="tad_applicant_title_store" [hasTitleNotSelected]='hasTitleNotSelected'></applicant-title>
            </div>
          </div>
          <div class="row">
            <div class="col col-md-6">
              <div class="form-group" [ngClass]="setDynamicClassesForFormgroup('tad_first_name')">
                <label for="tad_first_name">First name</label>
                <input type="text" class="form-control" [ngClass]="setDynamicClasses('tad_first_name')" formControlName="tad_first_name">
                <together-auction-dip-validate-fields [displayError]="tad_applicant_details_form.get('tad_first_name').touched && tad_applicant_details_form.get('tad_first_name').errors?.required"
                errorMsg="We need a first name."></together-auction-dip-validate-fields>
                <together-auction-dip-validate-fields [displayError]="tad_applicant_details_form.get('tad_first_name').touched && tad_applicant_details_form.get('tad_first_name').hasError('pattern')"
                errorMsg="Please enter a valid first name."></together-auction-dip-validate-fields>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col col-md-6">
              <div class="form-group" [ngClass]="{'is-invalid': tad_middle_name.dirty && tad_middle_name.invalid,'is-valid': tad_middle_name.dirty && tad_middle_name.valid}">
                <label for="tad_middle_name">Middle name (optional)</label>
                <input type="text" class="form-control" formControlName="tad_middle_name" [ngClass]="{'form-control-danger': tad_middle_name.dirty && tad_middle_name.invalid, 'form-control-success': tad_middle_name.dirty && tad_middle_name.valid}">
                <together-auction-dip-validate-fields [displayError]="tad_applicant_details_form.get('tad_middle_name').touched && tad_applicant_details_form.get('tad_middle_name').hasError('pattern')"
                errorMsg="Please enter a valid middle name."></together-auction-dip-validate-fields>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col col-md-6">
              <div class="form-group" [ngClass]="setDynamicClassesForFormgroup('tad_last_name')">
                <label for="tad_last_name">Last name</label>
                <input type="text" class="form-control" formControlName="tad_last_name" [ngClass]="setDynamicClasses('tad_last_name')">
          <together-auction-dip-validate-fields [displayError]="tad_applicant_details_form.get('tad_last_name').touched &&
                     tad_applicant_details_form.get('tad_last_name').errors?.required " errorMsg="We need a last name."></together-auction-dip-validate-fields>
                <together-auction-dip-validate-fields [displayError]="tad_applicant_details_form.get('tad_last_name').touched && tad_applicant_details_form.get('tad_last_name').hasError('pattern')"
                errorMsg="Please enter a valid last name."></together-auction-dip-validate-fields>
              </div>
            </div>
          </div>
          <div class="row ">
            <div class="col col-md-6 ">
              <fieldset class="form-group" [ngClass]="setDynamicClassesForFormgroup('tad_dob_day')">
                <label>Date of birth</label>
                <div class="d-flex ">
                  <div class="mr-1">
                    <label for="tad_dob_day" class="visually-hidden">Day (DD)</label>
                    <input type="number" class="form-control" [ngClass]="setDynamicClasses('tad_dob_day')" formControlName="tad_dob_day" pattern="[0-9]{1,2}"
                      title="You must provide a value between 1 and 31. (e.g. 10)" maxlength="2" placeholder="DD">
                    </div>
                    <div class="mr-1">
                      <label for="tad_dob_month" class="visually-hidden">Month (MM)</label>
                      <input type="number" class="form-control" [ngClass]="setDynamicClasses('tad_dob_month')" formControlName="tad_dob_month"
                        pattern="[0-9]{1,2}" title="You must provide a value between 1 and 12. (e.g. 12)" maxlength="2" placeholder="MM">
                      </div>
                      <div>
                        <label for="tad_dob_year" class="visually-hidden">Year (YYYY)</label>
                        <input type="number" class="form-control" [ngClass]="setDynamicClasses('tad_dob_year')" formControlName="tad_dob_year" pattern="[0-9]{4}"
                          title="You must provide a valid 4-number year. (e.g. 2017)" maxlength="4" placeholder="YYYY">
                        </div>
                      </div>
                      <together-auction-dip-validate-fields [displayError]="tad_applicant_details_form.get('tad_dob_year').touched && tad_applicant_details_form.get('tad_dob_year').errors?.required"
                      errorMsg="We need a Date of Birth."></together-auction-dip-validate-fields>
                      @if (tad_applicant_details_form.hasError('hasInvalidDate')) {
                        <div class="d-flex invalid-feedback form-control-feedback">Please enter a valid Date of Birth</div>
                      }
                      @if (tad_applicant_details_form.hasError('isUnderage')) {
                        <div class="d-flex invalid-feedback form-control-feedback">Unfortunately, we cannot add applicants under the age of 18.</div>
                      }
                    </fieldset>
                  </div>
                </div>
                <div class="row">
                  <div class="col col-md-6">
                    <div class="form-group" [ngClass]="setDynamicClassesForFormgroup('tad_main_phone_number')">
                      <label for="tad_main_phone_number">Main telephone number</label>
                      <input type="tel" [ngClass]="setDynamicClasses('tad_main_phone_number')" formControlName="tad_main_phone_number" class="form-control"
                        pattern="([0-9]+){7,10}" title="You must provide a valid phone number. Please include any area codes or other information in the number, without [], (), or {}."
                        id="tad_main_phone_number">
                        <together-auction-dip-validate-fields [displayError]="tad_applicant_details_form.get('tad_main_phone_number').touched && tad_applicant_details_form.get('tad_main_phone_number').errors?.required"
                        errorMsg="We need a telephone number."></together-auction-dip-validate-fields>
                        <together-auction-dip-validate-fields [displayError]="" errorMsg="Please enter a valid phone number, without spaces."></together-auction-dip-validate-fields>
          <together-auction-dip-validate-fields [displayError]="tad_applicant_details_form.get('tad_main_phone_number').touched && (tad_applicant_details_form.get('tad_main_phone_number').hasError('minlength') ||
                    tad_applicant_details_form.get('tad_main_phone_number').hasError('pattern'))" errorMsg="Please enter a valid phone number, without spaces."></together-auction-dip-validate-fields>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6">
                      <div class="form-group" [ngClass]="setDynamicClassesForFormgroup('tad_email_address')">
                        <label for="tad_email_address">Email address</label>
                        <div class="d-flex">
                          <div class="w-100">
                            <input type="email" class="form-control" [ngClass]="setDynamicClasses('tad_email_address')" formControlName="tad_email_address"
                              id="tad_email_address">
                            </div>
                          </div>
          <together-auction-dip-validate-fields [displayError]="tad_applicant_details_form.get('tad_email_address').touched &&
                    tad_applicant_details_form.get('tad_email_address').errors?.required" errorMsg="We need an email address."></together-auction-dip-validate-fields>
          <together-auction-dip-validate-fields [displayError]="tad_applicant_details_form.get('tad_email_address').touched &&
                    tad_applicant_details_form.get('tad_email_address').hasError('pattern')" errorMsg="Please enter a valid email address."></together-auction-dip-validate-fields>
                          <small class="form-text text-muted">
                            We need this to email your offer details if we can pre-approve your loan. You'll also be able to login and retrieve your
                            offer details at any time using your email address.
                          </small>
                        </div>
                      </div>
                    </div>
                    @for (address of movedInAddresses; track address; let i = $index) {
                      <together-auction-dip-applicant-moved-in-address [attr.data-index]="i"
                        [iterator]="i" [address]="address['LegalBodyRoleAddress']" (form_out)="_handleFormInFromAddress($event)" (outgoing_haslived3year)="handleHasLived3year($event)"
                        [children]="tad_applicant_details_form.controls.tad_addresses" [has_multiple_addresses]="hasMultipleAddresses" (loookUpformOut)="_handlelookupFormOut($event)"
                        [incomingApplicantSequence]="applicant.Instance.ApplicantSequence" [haslived3year]="_haslived3year" [hasLived3yearSelected]="hasLived3yearSelected"
                        [incoming_case_id]="incoming_case_id" [changedYear]="changedYear" [hasPostCodeNotEntered]="hasPostCodeNotEntered" (address_out)="handleAddressInFromAddress($event)">
                      </together-auction-dip-applicant-moved-in-address>
                    }
                    @if ((is_business_applicant == false && applicant.Instance.ApplicantSequence == 1) ||
                      (is_business_applicant == true && applicant.Instance.ApplicantSequence == 2)) {
                      <div class="row" >
                        <div class="col col-md-6 marketing-pref">
                          <fieldset>
                            <legend>Can we stay in touch?</legend>
                            <div class="d-flex mb-3">
                              <div class="w-40 mr-1">
                                <div class="c-radio--separated">
                                  <span class="c-radio-button">
                                    <input type="radio" name="tad_marketing_approval" [checked]="tad_marketing_approval.value === true || tad_marketing_approval.value === 'true'"
                                      formControlName="tad_marketing_approval" (click)="toggelMarketingPreference(true)" id="tad_marketing_approval_yes_{{applicant.Instance.ApplicantSequence}}"
                                      value="true">
                                      <label class="c-radio-button__label" for="tad_marketing_approval_yes_{{applicant.Instance.ApplicantSequence}}">
                                        <span class="c-radio-button__faux">Yes</span>
                                        <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 16 13">
                                          <path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" />
                                        </svg>
                                      </label>
                                    </span>
                                  </div>
                                </div>
                                <div class="w-40">
                                  <div class="c-radio--separated" d>
                                    <span class="c-radio-button">
                                      <input type="radio" name="tad_marketing_approval" [checked]="tad_marketing_approval.value === false || tad_marketing_approval.value === 'false'"
                                        formControlName="tad_marketing_approval" (click)="toggelMarketingPreference(false)" id="tad_marketing_approval_no_{{applicant.Instance.ApplicantSequence}}"
                                        value="false">
                                        <label class="c-radio-button__label" for="tad_marketing_approval_no_{{applicant.Instance.ApplicantSequence}}">
                                          <span class="c-radio-button__faux">No</span>
                                          <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 16 13">
                                            <path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" />
                                          </svg>
                                        </label>
                                      </span>
                                    </div>
                                  </div>
                                  <div class="w-20"></div>
                                </div>
                                @if (tad_marketing_approval.value === true || tad_marketing_approval.value === 'true') {
                                  <section>
                                    <small class="form-text text-muted mb-3 mt-0">
                                      Occasionally we’d like to send you information about products and services offered by our group companies (Together Personal
                                      Finance Limited, Together Commercial Finance Limited, Together123 Limited and Together Financial Services Limited).
                                      If you’d like to hear from us or our group companies, then please let us know how by ticking the boxes below.
                                    </small>
                                    <label class="mb-2">I’m happy to be contacted by Together and by Together's Group Companies by: </label>
                                    <div class="row">
                                      <div class="col-6">
                                        <label class="custom-control custom-checkbox">
                                          <input id="email" type="checkbox" name="checkbox-stacked" formControlName="email" [checked]= "email.value === true" class="custom-control-input">
                                          <span class="custom-control-indicator"></span>
                                          <span class="custom-control-description">Email</span>
                                        </label>
                                      </div>
                                      <div class="col-6">
                                        <label class="custom-control custom-checkbox">
                                          <input type="checkbox" formControlName="phone" [checked]="phone.value === true"  class="custom-control-input">
                                          <span class="custom-control-indicator"></span>
                                          <span class="custom-control-description">Phone</span>
                                        </label>
                                      </div>
                                      <div class="col-6">
                                        <label class="custom-control custom-checkbox">
                                          <input type="checkbox" formControlName="sms" [checked]="sms.value === true" class="custom-control-input">
                                          <span class="custom-control-indicator"></span>
                                          <span class="custom-control-description">SMS</span>
                                        </label>
                                      </div>
                                      <div class="col-6">
                                        <label class="custom-control custom-checkbox">
                                          <input type="checkbox" formControlName="post" [checked]="post.value === true"  class="custom-control-input">
                                          <span class="custom-control-indicator"></span>
                                          <span class="custom-control-description">Post</span>
                                        </label>
                                      </div>
                                    </div>
                                    <small class="form-text text-muted mb-3 mt-0">
                                      If you change your mind, you can contact us at any time to change your preferences.
                                    </small>
                                  </section>
                                }
                                <together-auction-dip-validate-fields [displayError]="tad_applicant_details_form.get('tad_marketing_approval').touched && tad_applicant_details_form.get('tad_marketing_approval').errors?.required"
                                errorMsg="Please choose Yes or No."></together-auction-dip-validate-fields>
                              </fieldset>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </form>
